import './component.scss'
import 'Components/nurikae/dropdown_button/component'
import 'Components/site/hamburger_menu/component'
import './dropdown_links_menu/component'
import './images/hamburger_icon.svg'
import './images/hamburger_icon_hover.svg'
import './images/hamburger_icon_close.svg'
import './images/hamburger_icon_close_hover.svg'

// ハンバーガーメニュー用オーバーレイを表示する関数
function showHamburgerOverlay () {
  document.body.classList.add('hamburger-overlay-target')
}

// ハンバーガーメニュー用オーバーレイを非表示にする関数
function hideHamburgerOverlay () {
  // すべてのオーバーレイクラスを削除
  const overlayElements = document.querySelectorAll('.hamburger-overlay-target')
  overlayElements.forEach(element => {
    element.classList.remove('hamburger-overlay-target')
  })
}

// ドロップダウンメニューを閉じる関数
function closeAllDropdownMenus () {
  // dropdown_button/component.jsで定義されている正確なクラス名を使用
  const dropdownTriggers = document.querySelectorAll('.js-dropdown-button-trigger')
  const dropdownMenus = document.querySelectorAll('.js-dropdown-menu-target')
  const dropdownArrows = document.querySelectorAll('.js-dropdown-arrow-target')

  // すべてのドロップダウンメニューを閉じる（dropdown_buttonの定数を使用）
  dropdownTriggers.forEach(trigger => {
    trigger.classList.remove('dropdown-button__trigger--open')
  })

  dropdownMenus.forEach(menu => {
    menu.classList.remove('dropdown-button__menu--show')
  })

  dropdownArrows.forEach(arrow => {
    arrow.classList.remove('dropdown-button__arrow--open')
  })

  // ドロップダウンのオーバーレイも非表示にする
  const dropdownOverlayElements = document.querySelectorAll('.dropdown-overlay-target')
  dropdownOverlayElements.forEach(element => {
    element.classList.remove('dropdown-overlay-target')
  })

  // ドロップダウンの強制閉鎖（追加の安全対策）
  try {
    // 追加の要素検索で取りこぼしを防ぐ
    const additionalTriggers = document.querySelectorAll('[class*="dropdown-button__trigger--open"]')
    const additionalMenus = document.querySelectorAll('[class*="dropdown-button__menu--show"]')
    const additionalArrows = document.querySelectorAll('[class*="dropdown-button__arrow--open"]')
    const additionalOverlays = document.querySelectorAll('[class*="dropdown-overlay-target"]')

    additionalTriggers.forEach(element => {
      element.classList.remove('dropdown-button__trigger--open')
    })

    additionalMenus.forEach(element => {
      element.classList.remove('dropdown-button__menu--show')
    })

    additionalArrows.forEach(element => {
      element.classList.remove('dropdown-button__arrow--open')
    })

    additionalOverlays.forEach(element => {
      element.classList.remove('dropdown-overlay-target')
    })
  } catch (e) {
    // エラーを無視して続行
  }
}

// ハンバーガーメニューを閉じる関数
function closeHamburgerMenu () {
  const hamburgerItem = document.querySelector('.js-globalNavigation-icon')
  const hamburgerText = document.querySelector('.js-globalNavigation-text')
  const hamburgerMenu = document.querySelector('.hamburger-menu')

  if (hamburgerItem && hamburgerText && hamburgerMenu) {
    hamburgerItem.classList.remove('is-active')
    hamburgerText.textContent = 'メニュー'
    hamburgerMenu.style.display = 'none'
    hideHamburgerOverlay()
    // ドロップダウンボタンを有効化
    document.body.classList.remove('hamburger-menu-active')
  }
}

// ハンバーガーアイコンのクリックイベント
document.addEventListener('DOMContentLoaded', () => {
  const hamburgerIcon = document.querySelector('.global-navigation__icon')
  const hamburgerItem = document.querySelector('.js-globalNavigation-icon')
  const hamburgerText = document.querySelector('.js-globalNavigation-text')
  const hamburgerMenu = document.querySelector('.hamburger-menu')
  const hamburgerMenuButton = document.querySelector('.js-globalNavigation-menuButton')

  if (hamburgerIcon && hamburgerItem && hamburgerText && hamburgerMenu && hamburgerMenuButton) {
    // ハンバーガーアイコンクリック時
    hamburgerMenuButton.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      // アクティブ状態を切り替え
      const isActive = hamburgerItem.classList.contains('is-active')

      if (isActive) {
        // メニューを閉じる
        hamburgerItem.classList.remove('is-active')
        hamburgerText.textContent = 'メニュー'
        hamburgerMenu.style.display = 'none'
        // オーバーレイを非表示
        hideHamburgerOverlay()
        // ドロップダウンボタンを有効化
        document.body.classList.remove('hamburger-menu-active')
      } else {
        // メニューを開く

        // ドロップダウンメニューを先に閉じる
        closeAllDropdownMenus()

        // 即座にハンバーガーメニューを開く（遅延を削除してチラつきを防ぐ）
        hamburgerItem.classList.add('is-active')
        hamburgerText.textContent = '閉じる'
        hamburgerMenu.style.display = 'block'
        // オーバーレイを表示
        showHamburgerOverlay()
        // ドロップダウンボタンを無効化
        document.body.classList.add('hamburger-menu-active')
      }
    })

    // 外部クリックでメニューを閉じる
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.js-globalNavigation-icon') &&
          !event.target.closest('.hamburger-menu')) {
        hamburgerItem.classList.remove('is-active')
        hamburgerText.textContent = 'メニュー'
        hamburgerMenu.style.display = 'none'
        // オーバーレイを非表示
        hideHamburgerOverlay()
        // ドロップダウンボタンを有効化
        document.body.classList.remove('hamburger-menu-active')
      }
    })

    // 初期状態では非表示
    hamburgerMenu.style.display = 'none'

    // ドロップダウンボタンがクリックされた時にハンバーガーメニューを閉じる
    const dropdownTriggers = document.querySelectorAll('.js-dropdown-button-trigger')
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        // ドロップダウンメニューが開かれる時にハンバーガーメニューを閉じる
        if (hamburgerItem.classList.contains('is-active')) {
          closeHamburgerMenu()
        }
      })
    })
  }
})
